<div class="scrolling-wrapper">
    <ms-scroll-adapter [scrollItems]="games()">
        @for (game of games(); track game.id; let index = $index) {
            <div class="banner-card-wrapper">
                <ds-card class="card-alignment" surface="lowest" [elevated]="false" [border]="false" (click)="openGame.emit({ game, index })">
                    <img placeholder ngSrcset="1x, 2x, 3x" [width]="80" [height]="80" [ngSrc]="game.imageUrl" />
                </ds-card>
            </div>
        }
    </ms-scroll-adapter>
</div>
